import {withFormik} from "formik";
import * as yup from "yup"
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {teachersApi} from "../../../constans/apiUrls";
import {GenderType} from "../../../constans/enumTypes";
import {ITeacherItemData} from "../../../contracts/data/teacher";
import InnerTeacherForm from "../../../components/FormTemplates/teacher/InnerTeacherForm";
import {phoneRegExp} from "../../../services/regex";


const teacherFormValidationSchema = yup.object().shape({
    first_name: yup.string().required("نام الزامی میباشد"),
    last_name: yup.string().required("نام خانوادگی الزامی میباشد"),
    mobile: yup.string().nullable().length(11, "شماره موبایل 11 رقم میباشد").matches(phoneRegExp, "شماره موبایل نادرست میباشد"),
    summary: yup.string().required("عنوان تخصصی الزامی میباشد"),
    avatar: yup.string().required("عکس الزامی میباشد"),
})

interface ITeacherFormProps {
    formType?: string,
}

const TeacherForm = withFormik<ITeacherFormProps, ITeacherItemData>({
    mapPropsToValues: props => ({
        id: 0,
        first_name: '',
        last_name: '',
        avatar: '',
        avatar_url: '',
        priority: 0,
        serial_code: '',
        mobile: '',
        age: 0,
        gender: GenderType.MALE,
        summary: '',
        description: '',
        skills: '',
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: teacherFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.avatar && isNotEmpty(values.avatar) && typeof values.avatar === 'object') {
            formData.append('avatar', values.avatar)
        }
        formData.append('data', JSON.stringify(values));
        if (formikBag.props.formType === 'create') {
            await httpClient().post(teachersApi.create, formData)
                .then(response => {
                    if(response.status === 201 || response.status === 200 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        } else if (formikBag.props.formType === 'edit') {
            await httpClient().put(`${teachersApi.update}/${values.id}`, formData)
                .then(response => {
                    if(response.status === 200){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        }
    },
    displayName: 'TeacherForm'
})(InnerTeacherForm)

export default TeacherForm